import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Button, IconButton, Typography } from "@material-ui/core";
import { Close } from "../../../LeftNav/SvgIcons";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    EndUserPaper: {
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 0px 6px 0px #00000040",
        borderRadius: "6px",
        width: "1100px",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        height: 80,
        borderBottom: "2px solid #E2E5E9",
        paddingRight: 20,
        paddingLeft: 28,
        background: "#00A3FF",
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
    },
    newPricingTypo: {
        fontSize: "22px",
        fontFamily: "Roboto",
        fontWeight: 500,
        color: "#fff",
    },
    inenerContent: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    text: {
        fontSize: 14,
        fontWeight: 700,
        fontFamily: "Roboto",
        paddingLeft: 16,
        color: "#464E5F",
    },
    ownerInput: {
        width: "691px",
        marginBottom: "10px",
    },
    content: {
        fontSize: 14,
        fontWeight: 700,
        fontFamily: "Roboto",
        paddingLeft: 16,
        color: "#3699FF",
        paddingRight: 19,
        letterSpacing: "-0.01em",
    },
    newOwner: {
        fontFamily: "Roboto",
        fontSize: "16px",
        fontWeight: "700",
        letterSpacing: " -0.02em",
        textAlign: "left",
        marginBottom: '8px',
    },
    endUserContent: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 50,
        fontSize: 22,
        fontWeight: 700,
        fontFamily: "Roboto",
        color: "#181C32",
    },
    inputControler: {
        display: "flex",
        flexDirection: "column",
        marginBottom: '8px',
    },
    ownerShipBtns: {
        display: "flex",
        flexDirection: "row",
        gap: "5px",
    },
    closIcon: {
        padding: "unset",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    hyperLink: {
        textDecoration: "none",
    },
    TypographyTxt: {
        fontSize: '14px',
        margin: '8px 0px',
    }
}));
export const DeleteContactTypeModal = ({
    open,
    contactType,
    onClose,
    onDeleteContactType
}) => {
    const classes = useStyles();

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={onClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.EndUserPaper}>
                        <div className={classes.header}>
                            <div className={classes.inenerContent}>
                                <Typography className={classes.newPricingTypo}>
                                    Remove Contact Type
                                </Typography>
                            </div>
                            <IconButton className={classes.closIcon} onClick={onClose}>
                                <Close />
                            </IconButton>
                        </div>
                        <div className="transferOnwershipModalContainer">
                            <div className={classes.endUserContent}>
                                <span>
                                    Are you sure you want to remove {contactType.nameSingularInternal}?
                                </span>
                                <Typography className={classes.TypographyTxt}>
                                </Typography>
                                <Button
                                    className="removeOwnerShip"
                                    onClick={() => {
                                        onDeleteContactType();
                                        onClose();
                                    }}
                                >
                                    Remove Contact Type
                                </Button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
};
